"use client";

import type { InventoryTransferRecord } from "@/lib/types";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { InventoryTransfersTable } from "./inventory-transfers-table";

interface InventoryTransfersTabsProps {
  data: InventoryTransferRecord[];
  readyCount: number;
  issueCount: number;
}

export function InventoryTransfersTabs({
  data,
  readyCount,
  issueCount,
}: InventoryTransfersTabsProps) {
  const readyData = data.filter((record) => record.status === "ready");
  const issueData = data.filter((record) => record.status === "issue");

  return (
    <Tabs defaultValue="all" className="w-full">
      <TabsList className="grid w-full max-w-2xl grid-cols-1 sm:grid-cols-3 h-auto">
        <TabsTrigger value="all" className="py-2">
          All ({data.length})
        </TabsTrigger>
        <TabsTrigger value="ready" className="gap-2 py-2">
          Ready for Transfer
          <Badge
            variant="outline"
            className="h-5 min-w-5 border-green-500 bg-green-50 px-1.5 text-[10px] text-green-800 dark:bg-green-950 dark:text-green-200"
          >
            {readyCount}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="issue" className="gap-2 py-2">
          Issues
          <Badge
            variant="destructive"
            className="h-5 min-w-5 border-transparent px-1.5 text-[10px]"
          >
            {issueCount}
          </Badge>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="all" className="mt-4">
        <InventoryTransfersTable data={data} />
      </TabsContent>

      <TabsContent value="ready" className="mt-4">
        <InventoryTransfersTable
          data={readyData}
          emptyMessage="No transfers are ready for Epicor inventory transfer."
          filterPlaceholder="Filter ready transfers..."
        />
      </TabsContent>

      <TabsContent value="issue" className="mt-4">
        <InventoryTransfersTable
          data={issueData}
          emptyMessage="No transfers with issues in this list."
          filterPlaceholder="Filter issue transfers..."
        />
      </TabsContent>
    </Tabs>
  );
}
